export const VALID_APP_ENVS = ['test', 'development', 'qa', 'staging', 'uat', 'production'];
export const ALLOWED_PORTALS = ['admin', 'patient', 'customer', 'pharmacist'];
export const viteCurrentPortal = () => {
    const portalName = import.meta.env.VITE_PORTAL_NAME;
    if (!ALLOWED_PORTALS.includes(portalName)) {
        throw new Error('Not a valid Circuit portal name');
    }
    return portalName;
};
export const viteAppEnv = () => {
    const appEnv = import.meta.env.VITE_APP_ENV;
    if (!appEnv) {
        throw new Error('App Environment not configured');
    }
    return appEnv;
};
export const viteApiBaseUrl = () => {
    const appBaseUrl = import.meta.env.VITE_API_BASE_URL;
    if (!appBaseUrl) {
        throw new Error('Api Base URL not configured');
    }
    return appBaseUrl;
};
export const viteWarehousingApiBaseUrl = () => {
    const warehousingApiUrl = import.meta.env.VITE_WAREHOUSING_API_URL;
    if (!warehousingApiUrl) {
        throw new Error('Warehousing API URL not configured');
    }
    return warehousingApiUrl;
};
export const vitePmsApiBaseUrl = () => {
    const baseUrl = import.meta.env?.VITE_PMS_API_BASE_URL;
    if (baseUrl === undefined) {
        throw new Error('PMS API Base URL not configured');
    }
    return baseUrl;
};
export const viteFFOverrides = () => {
    const ffOverrides = import.meta.env.VITE_FF_OVERRIDES;
    if (ffOverrides) {
        try {
            return JSON.parse(ffOverrides);
        }
        catch {
            throw new Error('VITE_FF_OVERRIDES is not a valid JSON string');
        }
    }
    return null;
};
export const appVersion = () => {
    const version = import.meta.env?.APP_VERSION;
    if (typeof version === 'string' && version !== '') {
        return version;
    }
    return undefined;
};
export const viteDomainSplitBaseUrl = (requiredPortal) => {
    const env = import.meta.env;
    const baseUrls = {
        admin: env.VITE_DSPLIT_ADMIN_BASE_URL,
        patient: env.VITE_DSPLIT_ALT_BASE_URL,
        customer: env.VITE_DSPLIT_UMEDS_BASE_URL,
        pharmacist: env.VITE_DSPLIT_PHARMACIST_BASE_URL,
    };
    if (!baseUrls[requiredPortal]) {
        throw new Error(`${requiredPortal} Base URL not configured`);
    }
    return baseUrls[requiredPortal];
};
export default null;
//# sourceMappingURL=data:application/json;base64,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